module.exports = __webpack_public_path__ + "img/CodeIcon.68252792.svg";